import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

export const generateGoogleCalendarLink = (event) => {
    /* 
    event:{
        title: event title,
        description: 
        location: address
        startTime:
        endTime:
    }
    */
    let start = event.startTime.toISOString().replace(/[.:-]/g, '')
    let end = event.endTime.toISOString().replace(/[.:-]/g, '')
    return `https://calendar.google.com/calendar/r/eventedit?text=${encodeURI(
        event.title || 'New Event'
    )}
&details=${encodeURI(event.description || 'No Description')}
&location=${encodeURI(event.location || 'At some place')}
&dates=${start}/${end}`
}

export const newWindow = (url) => {
    return () => {
        window.open(url, '_blank')
    }
}

 

export const calcDiscount = (price, discount) => {
    if (!discount || !['-', '*','+'].includes(discount[0])) {
        return Number(price).toFixed(2)
    }
    if (discount[0] === '-') {
        return Math.max(
            0,
            parseFloat(price) - parseFloat(discount.slice(1))
        ).toFixed(2)
    }
    if (discount[0] === '*') {
        return Math.max(
            0,
            parseFloat(price) * parseFloat(discount.slice(1))
        ).toFixed(2)
    }
    if (discount[0] === '+') {
        return Math.max(
            0,
            parseFloat(price) + parseFloat(discount.slice(1))
        ).toFixed(2)
    }
    return Number(price).toFixed(2)
}


export const saveTextToCSV = (text,filename)=>{
    const csvContent = 'data:text/csv;charset=utf-8,' + text;
    const uri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.href = uri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const mailto = (email)=>()=>{
    window.open(`mailto:${email}`,'_blank')
}

export const formatPhoneNumber = (value)=> {
    if (!value) {
        return '';
    }

    let p = value.replace(/[^\d]/g,'');
    return (p.length > 10)
        ? `+${p.slice(0,1)}-${p.slice(1,4)}-${p.slice(4,7) + '_'.repeat(3-p.slice(4,7).length)}-${p.slice(7,p.length) + '_'.repeat(4-p.slice(7,11).length)}`
        : `${p.slice(0,3)}${p.slice(3).length?'-'+p.slice(3,6):''}${p.slice(6).length?'-'+p.slice(6,p.length) :''}`;
}
 


/**
 * Generate random string from options
 * @param {number} length how long the string should be
 * @param {string} from upper + lower + number + special
 * @returns 
 */
export function randomString(length = 8, from = 'upper') {    
    let s = ''
    if (from.toLowerCase().includes('upper')) {
        s += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    }
    if (from.toLowerCase().includes('lower')) {
        s += 'abcdefghijklmnopqrstuvwxyz'
    }
    if (from.toLowerCase().includes('number')) {
        s += '0123456789'
    }
    if (from.toLowerCase().includes('special')) {
        s += '~!@#$%^&*()_-+=[]'
    }
    if (s==='') { // in case no valid options are given
        s = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~!@#$%^&*()_-+=[]'
    }
    const total = s.length
    let id = ''
    for (let i = 0; i < length; i++) {
        id += s[Math.floor(Math.random() * total)]
    }
    return id
}

export function randomPatientId () {
    return 'A' + randomString(7,'number')
}

export function getAnonymousSampleSubmissionUser(){
    const user = localStorage.getItem('anonymousSampleSubmissionUser')
    if (user) {
        return JSON.parse(user)
    } else {
        const newUser = {handledBy:'Anonymous User', handlerId:randomString(8)}
        localStorage.setItem('anonymousSampleSubmissionUser', JSON.stringify(newUser))
        return newUser
    }
}


export function AxiosErrorToString(err,key='error',defaultValue=null) {
    return err ?( err.response?
        (err.response.data?
            (err.response.data[key]?
                err.response.data[key]
                :(defaultValue===null? `${JSON.stringify(err.response.data)}`: defaultValue)
            )
            :
            `Server error: ${err.response.status}`
        )        
    :err.message) : 'Unknown error'
}

export const withHttp = url => !/^https?:\/\//i.test(url) ? `http://${url}` : url;

export const humanTimeFormat = (date,format) => {
    const dj = dayjs(date,format)
    return dj.isValid() ? `${dj.fromNow()}, on ${dj.format('MMM DD, YYYY hh:mm A')}` : ''
}

/**
* return if t1 is before t2 on the same day.
* t1 and t2 are both 09:00 AM or PM type of time
*/
export const isEarlier = (t1,t2)=>{
   const t1_ = dayjs(t1,'HH:mm A')
   const t2_ = dayjs(t2,'HH:mm A')
   return !t1_.isAfter(t2_)
}




/**
 * Generate a camelized string 
 * @param {string} str original string
 * @returns camelized string
 */
export function camelize(str) {
return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
}).replace(/\s+/g, '');
}


/**
 * calculate the net payment of an order.   
 * @param {*} order order document
 * @returns {{paid:number,refunded:number}} paid and refuned amount in dollars
 */
export function getOrderPayment(order) {
     // const orderType = data.orderType;
     const paymentType = order.paymentType;
     const refundAmount = order.refundAmount || 0;
     const orderDetails = order.orderDetails || {}     
     try {
         switch (paymentType) {
             case 'paypal':{
                 const paid  = parseFloat(orderDetails.purchase_units[0].payments.captures[0].amount.value)
                 return {paid, refunded:parseFloat(refundAmount) }
                 }
             case 'stripe':{        
                 const paid = parseFloat(orderDetails.amount || 0)  / 100      
                 return {paid, refunded:parseFloat(refundAmount)/100 }
             }
             default:
                 return {paid:0, refunded:0}
         }
     } catch (error) 
     {        
        return {paid:149, refunded:0}
     }    
}

/**
 * 
 * @param {number} t sleep time in milliseconds
 * @returns 
 */
export async function sleep(t) {
    return new Promise(resolve=>setTimeout(resolve, t));
}



/**
 * Normalize the name by converting accented characters to their non-accented counterparts.
 * Then convert to lower case,
 * THen remove any non alphanumeric characters.
 * @param {string} name name of the patient 
 */
export function nameNormalize(name) {
    return name && name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, '');
}